import * as React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../models/enums/breadcrumb';
import { KeyboardArrowRight } from '@material-ui/icons';
import * as styles from './common.module.scss';

interface Props {
  currentPage: string;
  breadcrumbs: Breadcrumb[];
}

/**
 * Breadcrumbs
 * @function Breadcrumbs - Component that shows path to current page (breadcrumbs)
 */
const Breadcrumbs = ({ breadcrumbs, currentPage }: Props) => {
  /**
   * @function renderBreadcrumbs - Renders each individual link/title and arrow
   */
  const renderBreadcrumbs = () => {
    return breadcrumbs.map((breadcrumb, index) => (
      // Full syntax for fragment needed in order to complete build
      <React.Fragment key={`breadcrumb-${index}`}>
        <Link to={breadcrumb.path}>{breadcrumb.title}</Link>
        <KeyboardArrowRight />
      </React.Fragment>
    ));
  };

  return (
    <div className={styles.breadcrumbs}>
      {renderBreadcrumbs()}
      <h1>{currentPage}</h1>
    </div>
  );
};

export default Breadcrumbs;
